<template>
  <div class="instructions" ref="roundtitle" tabindex="0">
    <div v-if="this.instruction">
      <div v-if="instructioncontent[this.instruction - 1]">
        <div v-if="instructioncontent[this.instruction - 1].stepTitle !== undefined">
          <h5>
            {{ instructioncontent[this.instruction - 1].stepTitle }}
          </h5>
        </div>
        <div
          v-if="instructioncontent[this.instruction - 1].content"
          v-html="instructioncontent[this.instruction - 1].content"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import nextButton from "../assets/button-next.svg";
import startButton from "../assets/button-start.svg";
import previousButton from "../assets/button-previous.svg";
import startOverButton from "../assets/button-startover.svg";

export default {
  name: "InstructionComponent",

  data() {
    return {};
  },
  watch: {
    instruction: function(newinstruction, oldinstruction) {
      this.setFocus();
    }
  },

  props: ["instruction", "disable", "instructioncontent"],

  computed: {
    cssStepValue: function() {
      let cssStepValue = "";
      if (this.instruction == 1) {
        cssStepValue = "stepOne";
      } else if (this.instruction === 6) {
        cssStepValue = "stepSix";
      }
      return cssStepValue;
    },

    startButton: function() {
      return startButton;
    },
    nextButton: function() {
      return nextButton;
    },
    previousButton: function() {
      return previousButton;
    },
    startOverButton: function() {
      return startOverButton;
    }
  },

  methods: {
    setFocus: function() {
      
        this.$refs.roundtitle.focus();
     
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/InstructionComponent.vue